import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M9.3 17.7a1 1 0 0 1 0-1.4l4.29-4.3-4.3-4.3a1 1 0 0 1 1.42-1.4l5 5a1 1 0 0 1 0 1.4l-5 5a1 1 0 0 1-1.42 0Z",
		clipRule: "evenodd"
	})
});
export default SvgChevronRightSmall;
